import React from "react";
import { SplitsReportPage } from "./splits-report-page";

export const PitchingSplitsReportPage = () => <SplitsReportPage kind="pitcher" />;
